module.exports = __webpack_public_path__ + "static/media/temp-firefighter.72fc7e19.jpg";